export const formattedTooltip = (data) => {
  const name = data.key ?? data.series.name;

  return `
  <div class="tooltip-bubble">
    <div class="tooltip-bubble__header">
      <div class="tooltip-bubble__point" style="background: ${data.color};"></div>
      <div class="tooltip-bubble__name">${name}</div>
    </div>

  ${data.y
    ? `<div class="tooltip-bubble__bottom">
      <span class="tooltip-bubble__value">${data.y}</span>
    </div>`
    : ''}
  </div>     
  `;
};
